// extracted by mini-css-extract-plugin
var _1 = "src-common-PageFrames-module__frame";
var _2 = "src-common-PageFrames-module__frame_content";
var _3 = "src-common-PageFrames-module__main_frame_area";
export { _1 as "frame", _2 as "frame_content", _3 as "main_frame_area" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"frame\":\"src-common-PageFrames-module__frame\",\"frame_content\":\"src-common-PageFrames-module__frame_content\",\"main_frame_area\":\"src-common-PageFrames-module__main_frame_area\"}";
        // 1777618596723
        var cssReload = require("../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  